export default __webpack_public_path__ + "static/5_35-db11e3f8fdb19bbbaf213be39293b72c.png";